import axios from "axios";
import { useMutation } from "@tanstack/react-query";
import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from "../Config/Config";

const saveApiEndpoints = async ({ testCaseId, testStepId, endpoints }) => {
  const userDetailString = localStorage.getItem("userDetail");
  if (!userDetailString) throw new Error("No user details found in localStorage");

  const user = JSON.parse(userDetailString);

  const response = await axios.post(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=saveApiEndpoints&companyid=${user.companyid}&testCaseId=${testCaseId}&testStepId=${testStepId}`,
    { endpoints },
  );

  return response.data;
};

const useSaveApiEndpoints = () => {
  return useMutation({
    mutationFn: (variables) => saveApiEndpoints(variables),
  });
};

export default useSaveApiEndpoints; 